module.exports = __webpack_public_path__ + "static/img/Lachie_Whitfield_mobile.8091f84.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Lachie_Whitfield_mobile.jpg
// module id = FwjO
// module chunks = 0